import { render } from "./vote-nav-button.vue?vue&type=template&id=e22e304c"
import script from "./vote-nav-button.vue?vue&type=script&lang=js"
export * from "./vote-nav-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__